import { render, staticRenderFns } from "./EnrollmentNew.vue?vue&type=template&id=b3ce4ebe&scoped=true&lang=pug&"
import script from "./EnrollmentNew.vue?vue&type=script&lang=js&"
export * from "./EnrollmentNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ce4ebe",
  null
  
)

export default component.exports